import React from 'react';
import image from '../../images/lili.png'
import Button from '../../share/button/Button';
import { useDispatch } from 'react-redux';
import { setModalStage } from '../../store/modalSlice';

const ModalInitial = () => {
    const dispatch = useDispatch();
    const startNewMint = () => {
        dispatch(setModalStage('CREATE_NEW_ETH'));
    }
    const startOgClaim = () => {
        dispatch(setModalStage('OG_CONNECT'));
    }

    return (
        <div className="flex flex-col items-center gap-1">
            <img src={image} className="w-[160px] sm:w-[200px] h-auto mb-2" alt="Lili" />
            <div className="flex flex-col gap-4 items-center w-full">
                <h2 className="text-white text-[clamp(1.75rem,6vw,3.5rem)] leading-tight">let's Start</h2>
                <Button onClick={startNewMint} size="cta">i'm new HERE</Button>
                <Button onClick={startOgClaim} size="cta">I'm an old holder</Button>
            </div>
        </div>
    );
};

export default ModalInitial;
